module.exports = __webpack_public_path__ + "img/horizontal_4_4_3.114f49a8.png";